var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trackingProgress"},[_c('div',{staticClass:"progress",style:({ width: _vm.computedPercentage})}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderView"},[_c('div',{staticClass:"bar"}),_c('div',{staticClass:"circleWrap"},[_c('span'),_c('span'),_c('span'),_c('span')])])
}]

export { render, staticRenderFns }